import React from 'react';

const PolicyPipelineCard = ({ policy, onOpen }) => {
  const updatedAt = new Date(policy.updated_at);
  const ageDays = Math.floor((Date.now() - updatedAt.getTime()) / (1000 * 60 * 60 * 24));
  const needsAttention = policy.status === 'in_review' && ageDays > 7;

  return (
    <article className={`pipeline-card ${needsAttention ? 'pipeline-card--attention' : ''}`}>
      <h4>{policy.title}</h4>
      <p className="muted">{policy.project_name} • v{policy.publish_version}</p>
      <p className="muted">Reviewer: {policy.reviewer_name || 'Unassigned'}</p>
      <p className="muted">Comments: {policy.comment_count} ({policy.unresolved_comment_count} open)</p>
      <p className="muted">Updated {ageDays}d ago</p>
      {needsAttention && <p className="alert">Needs attention</p>}
      <button className="btn btn--sm" onClick={() => onOpen(policy)}>Open</button>
    </article>
  );
};

export default PolicyPipelineCard;
